import "./styles.css";
import { useState, useCallback, useEffect } from "react";
import contato from "./images/contato.svg";
import contatoBranco from "./images/contatoBranco.svg";
import conteudo from "./images/conteudo.svg";
import conteudoBranco from "./images/conteudoBranco.svg";
import enviar from "./images/enviar.svg";
import enviarBranco from "./images/enviarBranco.svg";
import mais from "./images/mais.svg";
import maisBranco from "./images/maisBranco.svg";
import calculadora from "./images/calculadora.png";
import calculadoraBranco from "./images/calculadoraBranco.png";
import casa from "./images/casa.svg";
import casaBranco from "./images/casaBranco.svg";
import calendario from "./images/Calendario.svg";
import calendarioBranco from "./images/CalendarioBranco.svg";

import seta from "./images/seta.svg";
import logo from "./images/AXS-logo.svg";
import ButtonLogoff from "./images/ButtonLogoff.svg";
import ModalLink from "../Modais/ModalLink";
import api from "../../services/api/index";
import Toast from "../Toast/Toast";
import { Table } from "../TableFilter/Tables/Table";
import { GeradorDePropostas } from "../GeradorDePropostas/index";
import { Calculadora } from "../Calculadora/index";
import Contato from "../Contato/Contato.js";
import { useAPI } from "../../hooks/contextApis";
import version from "../../../package.json";
import { writeStorage, readDataStorage } from "../../utils/storage/storage";
import SearchIcon from "@mui/icons-material/Search";
import { PesquisaUc } from "../PesquisaUc";
import { ModalCopy } from "../ModalCopy/Modal";
import { ViewUser } from "../ViewUser/ViewUser.tsx";
import error from "../../components/Toast/Image/error.svg";
import { AreaConteudos } from "../AreaConteudos";
import { AnaliseProposta } from "../AnaliseProposta";
import { NotificationsButton } from "../Notifications/NotificationsButton";
import NotificationsModal from "../Notifications/NotificationsModal";
import CalendarView from '../ViewUser/CalendarView';
import { LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

dayjs.locale('pt-br');


export default function Grid() {
  const {
    NomeRepresentante,
    CodigoLink,
    TipoVendedor,
    RazaoRepresentante,
    IdCard
  } = readDataStorage("login");
  const [linkApi, setLinkApi] = useState("");
  const [list] = useState([]);
  const {
    isEditing,
    isOpenUser,
    isOpenCompromisso,
    active,
    setIsOpenCancel,
    setDados,
    headerLabel,
    handleClickPage,
  } = useAPI();
  const [modalUc, setModalUc] = useState(false);
  const [modalCopy, setModalCopy] = useState(false);
  const [isSignOut, setIsSignOut] = useState(false);
  const [listToast, setListToast] = useState([]);

  let toastProperties = null;

  const showToast = useCallback(
    (type) => {
      const id = Math.floor(Math.random() * 101 + 1);

      switch (type) {
        case "403":
          // eslint-disable-next-line react-hooks/exhaustive-deps
          toastProperties = {
            id,
            title: "",
            description: "Acesso não autorizado",
            backgroundColor: "#f0ad4e",
            icon: error,
          };
          break;

        default:
          listToast([]);
      }

      setListToast([...list, toastProperties]);
    },
    [toastProperties]
  );

  useEffect(() => {
    writeStorage({
      key: "appVersion",
      object: {
        versionStorage: version.version,
      },
    });
  }, []);

  useEffect(() => {
    if (!isEditing && isSignOut) {
      sessionStorage.removeItem("@AXS-Energia:token");
      window.location.href = "/arp/login";
    }
  }, [isEditing, isSignOut]);

  const Auth = {
    authenticate(cb) {
      setTimeout(cb, 1000); // fake async
    },
    signout(cb) {
      switch (isEditing) {
        case true:
          setIsSignOut(true);
          setIsOpenCancel(true);
          break;
        case false:
          excluirSessao().finally(() => {
            sessionStorage.removeItem("@ARP-Energia:token");
            setTimeout(cb, 0);
          });
          break;
        default:
          break;
      }
    },
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const toLink = () => {
    api.defaults.headers.common = {
      Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
    };
    api
      .post(`/csp/representante/gerarlink/`, {
        representante: CodigoLink,
      })
      .then((res) => {
        setLinkApi(res.data["link"]);
        if (res.status === 200) {
          setModalCopy(true);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          showToast("403");
        }
      });
  };

  const toGet = () => {
    setDados({ id: IdCard });
  };


  window.onload = function () {
    let btn = document.querySelector("#btn");
    let sidebar = document.querySelector(".sidebar");
    let searchBtn = document.querySelector(".bx-search");

    btn.addEventListener("click", () => {
      sidebar.classList.toggle("active");
    });

    searchBtn.addEventListener("click", () => {
      sidebar.classList.toggle("active");
    });

    toGet();
  };

  const [modalIsOpenLink, setIsOpenLink] = useState(false);
  const closeModal = () => {
    setIsOpenLink(false);
  };

  const sections = [
    { id: "default", component: <Table /> },
    { id: "calendario", component: 
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <CalendarView />
    </LocalizationProvider>
    },
    { id: "GPCR", component: <GeradorDePropostas /> },
    { id: "Contato", component: <Contato /> },
    { id: "Conteudo", component: <AreaConteudos /> },
    { id: "AnaliseProposta", component: <AnaliseProposta /> },
    { id: "Calculadora", component: <Calculadora /> },
  ];

  const excluirSessao = async () => {
    try {
      await api.delete("/csp/representante/sessao/excluir", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
        },
      });
      console.log("Sessão excluída com sucesso.");
    } catch (error) {
      console.error("Erro ao excluir sessão:", error);
    }
  };

  return (
    <>
      <NotificationsModal />

      <Toast toastList={list} autoDelete={true} />
      <ModalLink
        isOpen={modalIsOpenLink}
        onRequestClose={closeModal}
        rowIdxVisual={"link"}
        titulo={undefined}
      />

      <div className="sidebar">
        <div className="logo_content">
          <img alt={""} className="bx bx-menu" id="btn" src={seta}></img>
        </div>

        <div>
          <img alt={""} className="bx bx-grid-alt"></img>
          <img alt={""} className="bx bx-grid-alt"></img>
        </div>
        <div>
          <p className="bx bx-grid-alt nomeRepresentante">
            {NomeRepresentante}
          </p>
        </div>

        <div>
          <p></p>
          <p></p>
        </div>
        <div className="side-menu-container">
          <div className="nav-container">
            <ul className="nav_list">
              <li>
                <i className="bx bx-search"></i>
              </li>
              <li style={{ cursor: "pointer" }}>
                <p
                  onClick={(e) => {
                    handleClickPage("default");
                  }}
                  id="btnMinhasPropostas"
                >
                  <span className={`${active === "default" ? "Hover" : ""}`}>
                    <img
                      alt={""}
                      className="bx bx-grid-alt"
                      src={active === "default" ? casaBranco : casa}
                    ></img>
                  </span>
                  <span className="links_name">Minhas propostas</span>
                </p>
              </li>
              <li style={{ cursor: "pointer" }}>
                <p
                  onClick={(e) => {
                    handleClickPage("calendario");
                  }}
                  id="btnMinhasPropostas"
                >
                  <span className={`${active === "calendario" ? "Hover" : ""}`}>
                    <img
                      alt={""}
                      className="bx bx-grid-alt"
                      src={active === "calendario" ? calendarioBranco : calendario}
                    ></img>
                  </span>
                  <span className="links_name">Meus compromissos</span>
                </p>
              </li>
              <li style={{ cursor: "pointer" }}>
                <p
                  onClick={(e) => {
                    handleClickPage("GPCR");
                  }}
                  id="btnRedirectGPCR"
                >
                  <span className={`${active === "GPCR" ? "Hover" : ""}`}>
                    <img
                      alt={""}
                      className="bx bx-grid-alt"
                      src={active === "GPCR" ? maisBranco : mais}
                    ></img>
                  </span>
                  <span className="links_name">Gerar nova proposta</span>
                </p>
              </li>
              <li
                style={
                  TipoVendedor === "Pós Venda"
                    ? { display: "none" }
                    : { cursor: "pointer" }
                }
                id="btnLinkProposta"
                onClick={(e) => {
                  toLink();
                }}
              >
                <p>
                  <span className={`${modalCopy ? "Hover" : ""}`}>
                    <img
                      alt={""}
                      className="bx bx-user"
                      src={modalCopy ? enviarBranco : enviar}
                    ></img>
                  </span>
                  <span className="links_name">Enviar meu link</span>
                </p>
              </li>
              <div
                id="Link"
                style={{
                  color: "transparent",
                  position: "absolute",
                  top: "100%",
                }}
              >
                {linkApi}
              </div>
              <li
                id="btnConteudos"
                onClick={(e) => {
                  handleClickPage("Conteudo");
                }}
                style={{ cursor: "pointer" }}
              >
                <p>
                  <span className={`${active === "Conteudo" ? "Hover" : ""}`}>
                    <img
                      alt={""}
                      className="bx bx-chat"
                      src={active === "Conteudo" ? conteudoBranco : conteudo}
                    ></img>
                  </span>
                  <span className="links_name">Área de conteúdos</span>
                </p>
              </li>
              <li style={{ cursor: "pointer" }}>
                <p
                  id="btnContatos"
                  onClick={(e) => {
                    handleClickPage("Contato");
                  }}
                >
                  <span className={`${active === "Contato" ? "Hover" : ""}`}>
                    <img
                      alt={""}
                      className="bx bx-pie-chart-alt-2"
                      src={active === "Contato" ? contatoBranco : contato}
                    ></img>
                  </span>
                  <span className="links_name">Entrar em contato</span>
                </p>
              </li>
              <li style={{ cursor: "pointer" }}>
                <p
                  id="btnCalculadora"
                  onClick={(e) => {
                    handleClickPage("Calculadora");
                  }}
                >
                  <span
                    className={`${active === "Calculadora" ? "Hover" : ""}`}
                  >
                    <img
                      alt={""}
                      className="bx bx-pie-chart-alt-2"
                      src={
                        active === "Calculadora"
                          ? calculadoraBranco
                          : calculadora
                      }
                    ></img>
                  </span>
                  <span className="links_name">Simular proposta</span>
                </p>
              </li>

              <li style={{ cursor: "pointer" }}>
                <p
                  id="btnPesquisaUc"
                  onClick={(e) => {
                    setModalUc(true);
                  }}
                >
                  <span className={`${modalUc ? "Hover" : ""}`}>
                    <SearchIcon style={modalUc ? { color: "white" } : {}} />
                  </span>
                  <span className="links_name">Consulta UC</span>
                </p>
              </li>
            </ul>
          </div>
          <div className="logout-container">
            <button
              onClick={() => {
                Auth.signout(() => (window.location.href = "/arp/login"));
              }}
              alt={""}
              className="buttonLogout"
            >
              <p>Sair</p>
              <img alt={""} src={ButtonLogoff}></img>
            </button>
            <img alt={""} className="logo" src={logo}></img>
          </div>
        </div>
      </div>
      <div className="home_content">
        <div className="topBar">
          <span>{headerLabel}</span>

          <NotificationsButton />
        </div>
        <div className="rightSide">
          {!isOpenCompromisso && isOpenUser && <ViewUser />}
          {isOpenCompromisso &&       
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <CalendarView />
              </LocalizationProvider>
            }
          {!isOpenUser && (
            <>
              {sections
                .filter((section) => section.id === active)
                .map((section) => (
                  <div key={section.id}>{section.component}</div>
                ))}
            </>
          )}
          <PesquisaUc open={modalUc} onClose={() => setModalUc(false)} />
          <ModalCopy
            link={linkApi}
            open={modalCopy}
            onClose={() => setModalCopy(false)}
            razaoSocial={RazaoRepresentante}
            nome={NomeRepresentante}
          />
        </div>
      </div>
    </>
  );
}
